<template>
  <section>
    <div
      class="my3"
      v-show="$route.name === 'COMPLETE-PERGUNTA'"
    >
      <h2>
        {{$dados.PERGUNTA.LEI}} - {{$dados.PERGUNTA.DESCRICAO}}
      </h2>
      <h3 class="py2">
        {{$dados.PERGUNTA.ENUNCIADOCORRETO}}
      </h3>
    </div>
    <div
      v-show="$route.name === 'QUESTOES-PERGUNTA'"
      class="my3"
    >
      <div class="table-container table-theme-1">
        <table>
          <tbody>
            <tr
              v-for="(alternativa, $index) in $dados.PERGUNTA.ALTERNATIVAS"
              :key="alternativa.resposta"
            >
              <td style="text-align: left">
                <p
                  :class="getClassAlternativa($index)"
                  class="m0 p2"
                >
                  {{alternativa}}
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div
      v-show="$dados.RESULTADO.JUSTIFICATIVA"
      class="my3"
    >
      <h3>
        Justificativa: {{$dados.RESULTADO.JUSTIFICATIVA}}
      </h3>
    </div>
    <div class="my3">
      <fundamentacaoLegal :records="$dados.RESULTADO.FUNDAMENTACAOLEGAL"></fundamentacaoLegal>
    </div>
    <div class="my3">
      <fundamentacaoApostila :records="$dados.RESULTADO.FUNDAMENTACAOAPOSTILA"></fundamentacaoApostila>
    </div>
    <resumoDeRodadas
      v-show="$dados.RODADA.QTDEEXERCICIOS !== $dados.RODADA.QTDERESPOSTAS"
      :rodada="$route.params.rodada"
    ></resumoDeRodadas>
  </section>
</template>

<script>
import fundamentacaoLegal from '@/custom/fundamentacaoLegal'
import fundamentacaoApostila from '@/custom/fundamentacaoApostila'
import resumoDeRodadas from '@/custom/resumoDeRodadas'
var componentDefinition = {
  components: { fundamentacaoLegal, fundamentacaoApostila, resumoDeRodadas },
  props: ['refresh'],
  watch: {
    '$route.path': {
      handler: function (path) {
        // Escrotidão pq o dialog mantém o scroll "embaixo" ao ser reaberto
        this.$el.parentElement.scrollTop = 0
      },
      deep: true
    }
  },
  methods: {
    getClassAlternativa: function ($index) {
      var cssClass = ''
      var resposta = $index + 1
      if (resposta === this.$dados.PERGUNTA.RESPOSTACERTA) {
        cssClass = ' bg-green white bold'
      } else if (this.$dados.RESPOSTA === resposta) {
        cssClass = ' bg-red white bold'
      }
      return cssClass
    }
  }
}
export default componentDefinition
</script>
